import { updateProviderMemo } from "@/api/providerDashboard";

export default {
  openMemoModal(item) {
    this.memoScheduleId = item._id;
    this.memoText = item.providerMemo || "";
    this.showMemoModal = true;
  },
  async submitMemo() {
    try {
      await updateProviderMemo(this.memoScheduleId, {
        providerMemo: this.memoText,
      });
      this.$message.success("메모가 저장되었습니다.");
      this.showMemoModal = false;
      this.loadSchedules();
    } catch (err) {
      this.$alert("메모 저장 실패");
    }
  },
};
